<script setup lang="ts">
import type { TrekRouteVariant } from "@/composables/useTrekPackageSummary";

const props = defineProps<{
  trekTitle: string;
  variant: TrekRouteVariant;
  /** CMS map link used when the matched package has no trek_link. */
  fallbackLink?: string | null;
}>();

const { summaryForVariant } = useTrekPackageSummary(() => props.trekTitle);

const summary = computed(() => summaryForVariant(props.variant));

const itineraryLink = computed(() => {
  const fromPackage = summary.value?.itineraryPath?.trim() ?? "";
  if (fromPackage) return fromPackage;
  return String(props.fallbackLink ?? "").trim();
});
</script>

<template>
  <div v-if="itineraryLink" class="map-route-package">
    <div class="map-route-package__actions">
      <NuxtLink class="btn from-left" :to="itineraryLink">
        View Trek Itinerary
      </NuxtLink>
    </div>
  </div>
</template>
